import { getCookieCloseBanner } from '@space-shell/common/components/pwaBar/utils'
import { AuthStatus, useAuthContext } from '@space-shell/common/contexts/auth'
import { useMembershipStore, useViewAsStore } from '@space-shell/core/store'
import { useAuthStore } from '@space-shell/core/store/useAuthStore'
import { useTranslation } from 'react-i18next'

const useCanRenderPwaBanner = () => {
  const { authStatus } = useAuthContext()
  const { id } = useAuthStore()
  const { membershipSlug, membershipData } = useMembershipStore()
  const { isEnabled: isViewAsEnabled } = useViewAsStore()
  const {
    i18n: { language }
  } = useTranslation()

  const lang = language.toLocaleLowerCase()
  const availableRoutesToRender = [
    `/${lang}/club/${membershipSlug}`,
    `/${lang}/club/${membershipSlug}/products`
  ]
  const canRenderOnRoute = availableRoutesToRender.includes(location?.pathname)

  const hasHideBannerCookie = getCookieCloseBanner(membershipSlug)

  const hasPwaConfigActive =
    membershipData?.settings?.application?.some(({ switchPwa }) => switchPwa) ?? false

  const isAuthenticating = authStatus === AuthStatus.AUTHENTICATING
  const isRenewing = authStatus === AuthStatus.RENEWING
  const isOwner = Boolean(Number(id) === membershipData?.ownerId)

  if (isOwner || isRenewing || isAuthenticating) return { canRenderPwaBanner: false }

  const canRenderPwaBanner =
    Boolean(
      !hasHideBannerCookie &&
        !isViewAsEnabled &&
        membershipData &&
        canRenderOnRoute &&
        hasPwaConfigActive
    ) ?? false

  return {
    canRenderPwaBanner
  }
}

export default useCanRenderPwaBanner
